module.exports = __webpack_public_path__ + "img/ukrbyd.ec2cdfa8.jpg";